import { cn } from '@/lib/cn';

export function Logo({ className, showText = true }: { className?: string; showText?: boolean }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <svg viewBox="0 0 64 64" className="h-8 w-8 shrink-0" aria-hidden>
        <rect width="64" height="64" rx="14" fill="currentColor" className="text-brand-500" />
        <path
          d="M20 22c0-3.3 2.7-6 6-6h12c3.3 0 6 2.7 6 6v2h-8v-2h-8v6h10c3.3 0 6 2.7 6 6v8c0 3.3-2.7 6-6 6H26c-3.3 0-6-2.7-6-6v-2h8v2h8v-6H26c-3.3 0-6-2.7-6-6v-8z"
          fill="white"
        />
      </svg>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-display text-[17px] font-bold tracking-tight text-ink">SCGMEX</span>
          <span className="text-[10px] font-medium uppercase tracking-[0.14em] text-ink-mute">
            Gestión Gubernamental
          </span>
        </div>
      )}
    </div>
  );
}
